/** @class AddResponseButton
 *
 * @desc
 * Shared `button` component that opens an item modal for a new response entry

 * @property {Map} item
 * @property {Map} kit
 *
 **/

import {Map} from 'immutable'
import {useState} from 'react'
import PropTypes from 'prop-types'

import PlusIcon from '../../../../../shared_components/core/svg_icons/icons/PlusIcon'
import AddLifeStoryChooser from '../life_story/AddLifeStoryChooser'

import {firstTopKitParentElementId, isCompoundItemResponse} from '../../../../../lib/plan_data/itemResponsesHelper'
import {ETHICAL_WILL_ITEM_SLUG} from '../life_story/lifeStoryTools'
import {newItemPath} from '../../../../../lib/urlTools'
import routerUtils from '../../../../../lib/routerUtils'
import Logger from '../../../../../lib/NewLogger'
import {accountEntrySelectPath} from '../../../../../lib/urlTools'
import {eligibleForAccountsImport} from '../../../../../lib/accountPopulationTools'

const AddResponseButton = props => {
  const [showLifeStoryChooser, setShowLifeStoryChooser] = useState(false)
  const logAddAnother = () => {
    const itemName = props.itemResponse.get('name')

    Logger.log({
      name: 'clicked_add_another',
      payload: {
        context: props.context,
        type: 'vault',
        item: itemName,
        wildcard: itemName,
        compound_item: isCompoundItemResponse(props.itemResponse)
      }
    })
  }

  /** Constructs the URL path to the Item Modal when requesting to add a new item response. */
  const addNew = () => {
    routerUtils.push(
      newItemPath({
        elementId: firstTopKitParentElementId(props.itemResponse),
        itemSlug: props.itemResponse.get('slug'),
        slug: props.categorySlug,
        path: props.location.pathname
      })
    )
  }

  const onClickAddNew = () => {
    logAddAnother()

    // The Life Story chooser shows only when the firm has My Story access
    // (funeral homes plus whitelisted firms, TK-3197): anyone else adding to
    // the Ethical Will item gets the classic form.
    if (props.itemResponse.get('slug') === ETHICAL_WILL_ITEM_SLUG && props.actor === 'planholder' && props.hasMyStoryAccess)
      setShowLifeStoryChooser(true)
    else if (eligibleForAccountsImport({item: props.itemResponse, userConfig: props.userConfig}))
      routerUtils.push(accountEntrySelectPath({itemSlug: props.itemResponse.get('slug'), path: props.location.pathname}))
    else
      addNew()
  }

  return (
    <>
      <button aria-label={`Add ${props.itemResponse.get('name')}`} className='add-response-button flex-child' type='button' onClick={onClickAddNew}>
        <PlusIcon fill='#FFF' width='10' height='10' />
      </button>
      {
        showLifeStoryChooser &&
          <AddLifeStoryChooser
            addClassic={addNew}
            exit={() => setShowLifeStoryChooser(false)}
            userConfig={props.userConfig}
          />
      }
    </>
  )
}

AddResponseButton.defaultProps = {
  children: 'Add'
}

AddResponseButton.propTypes = {
  actor: PropTypes.string,
  category: PropTypes.instanceOf(Map),
  categorySlug: PropTypes.string,
  context: PropTypes.string,
  hasMyStoryAccess: PropTypes.bool,
  itemResponse: PropTypes.instanceOf(Map).isRequired,
  location: PropTypes.object,
  userConfig: PropTypes.instanceOf(Map).isRequired
}

export default AddResponseButton
